import classnames from 'classnames'
import { memo } from 'react'
import Tilt from 'react-parallax-tilt'

const defaultOptions = {
  perspective: 1000,
  glareEnable: true,
  glareMaxOpacity: 0.2,
  scale: 1.05,
  gyroscope: true,
  tiltMaxAngleX: 10,
  tiltMaxAngleY: 10
}

const TiltCard = ({ children, className, ...props }) => {
  const cn = classnames('tilt-card', className)

  return (
    <Tilt className={cn} {...defaultOptions} {...props}>
      {children}
    </Tilt>
  )
}

export default memo(TiltCard)
